import { FormControl, MenuItem, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { TransportType } from "../../store/transport-types";

export type ShiftTransportValue = "" | TransportType;

interface ShiftTransportSelectProps {
	value: ShiftTransportValue;
	onChange: (value: ShiftTransportValue) => void;
	disabled?: boolean;
}

// What a shift offers, set by the supervisor who knows which end of it falls
// outside the plant shuttle's hours. The worker never picks a direction — this
// choice fixes it — and a shift offering transport never obliges anyone to
// take it.
const ShiftTransportSelect = ({
	value,
	onChange,
	disabled = false,
}: ShiftTransportSelectProps) => {
	const { t } = useTranslation();

	const labels: Record<TransportType, string> = {
		P: t("transport_shift-offers-pickup"),
		D: t("transport_shift-offers-drop-off"),
		B: t("transport_shift-offers-both"),
	};

	return (
		<FormControl variant='filled' fullWidth>
			<TextField
				select
				variant='filled'
				name='transportType'
				id='transportType'
				label={t("transport_shift-transport")}
				value={value}
				disabled={disabled}
				onChange={(event) =>
					onChange(event.target.value as ShiftTransportValue)
				}
				helperText={t("transport_shift-transport-helper")}
				fullWidth
				InputLabelProps={{ shrink: true }}
				SelectProps={{
					displayEmpty: true,
					renderValue: (selected: unknown) => {
						const code = selected as ShiftTransportValue;
						if (!code) {
							return (
								<Typography
									sx={{
										fontFamily: "Roboto",
										fontSize: "16px",
										color: "rgba(0, 0, 0, 0.6)",
									}}
								>
									{t("transport_shift-offers-none")}
								</Typography>
							);
						}
						return labels[code];
					},
				}}
			>
				<MenuItem value=''>{t("transport_shift-offers-none")}</MenuItem>
				<MenuItem value='P'>{labels.P}</MenuItem>
				<MenuItem value='D'>{labels.D}</MenuItem>
				<MenuItem value='B'>{labels.B}</MenuItem>
			</TextField>
		</FormControl>
	);
};

export default ShiftTransportSelect;
